/**
 * Cross-tree notifications used by the sidebar badges. The pages that consume a counter
 * live far away from the badge in the component tree, so a DOM event is the cheapest way
 * to tell the badge that its value is stale right after a local interaction.
 */
export const PENDING_REPLIES_INTERACTED_EVENT = 'pendingRepliesInteracted';

export const emitPendingRepliesInteracted = () => {
  window.dispatchEvent(new CustomEvent(PENDING_REPLIES_INTERACTED_EVENT));
};
